/** * 模块名称: VoiceRecorder.vue - 录音笔 * 模块说明: * 创建时间: 2022-02-15
11:36 * 模块负责人: lkc * 修改记录: */
<template>
  <div>
    <!-- 头部 -->
    <div class="headBanner">
      <div class="headClass">
        <div class="tit">
          <h1>一站式解决工作、生活中的即时记录难题</h1>
        </div>
        <!-- <img src="@/assets/yj5.png" alt="" /> -->
        <div class="div"></div>
      </div>
    </div>
    <div class="contBox">
      <!--选择我们的六大理由  -->
      <h1>选择我们的六大理由</h1>
      <ul class="subsystemCont">
        <li
          v-for="item in listArr"
          :key="item.id"
          @mouseenter="mshow(index)"
          @mouseleave="mhidden(index)"
        >
          <!-- <img :src="item.url" alt=""> -->
          <span class="subsystemSpan">{{ item.tit }}</span>
          <!-- 蒙层 -->
          <div class="mask" v-show="aaaa">
            <span>{{ item.tit }}</span>
            <span>{{ item.cont }} </span>
          </div>
        </li>
      </ul>
      <!-- 政、企事业单位应用场景全覆盖 -->
      <h1>政、企事业单位应用场景全覆盖</h1>
      <ul class="subsystemConts">
        <li
          v-for="item in listArr1"
          :key="item.id"
          @mouseenter="mshow(index)"
          @mouseleave="mhidden(index)"
        >
          <span class="subsystemSpan">{{ item.tit }}</span>
          <img :src="item.url" alt="" />
          <!-- 蒙层 -->
          <div class="mask" v-show="aaaa">
            <span>{{ item.tit }}</span>
            <span>{{ item.cont }} </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listArr: [
        {
          id: 1,
          url: require('@/assets/yc4.png'),
          tit: '清晰收音',
          cont: 'A.I.专业降噪'
        },
        {
          id: 2,
          url: require('@/assets/yc4.png'),
          tit: '精准转写',
          cont: '转写准确率高，涵盖多语种转写'
        },
        {
          id: 3,
          url: require('@/assets/yc4.png'),
          tit: '顺滑操作',
          cont: '全新的外观设计，触摸屏结合实体按键'
        },
        {
          id: 4,
          url: require('@/assets/yc4.png'),
          tit: '全面场景',
          cont: '政、企事业单位日常办公使用场景全面覆盖'
        },
        {
          id: 5,
          url: require('@/assets/yc4.png'),
          tit: '声纹识别',
          cont: '依据声纹区分不同发言人，并在输出时，标记发言人'
        },
        {
          id: 6,
          url: require('@/assets/yc4.png'),
          tit: '轻巧便携',
          cont: '迷你尺寸，携带方便'
        }
      ],
      listArr1: [
        {
          id: 1,
          url: require('@/assets/ly1.png'),
          tit: '会议',
          cont: '适用于各类需实时整理会议记录的场景，会时录音，会后整理，使办公提质增效'
        },
        {
          id: 2,
          url: require('@/assets/ly2.png'),
          tit: '庭审',
          cont: '实现、庭审笔录自动生成、庭审笔录音频即时回听及快速检索等功能，可有效提升审判质效'
        },
        {
          id: 3,
          url: require('@/assets/ly3.png'),
          tit: '培训',
          cont: '轻松实现课上录音，课后随时听、反复听，提升学习质量'
        },
        {
          id: 4,
          url: require('@/assets/ly4.png'),
          tit: '取证',
          cont: '凭借声纹识别技术，实现精准的分角色拾音，把语音实时转写成文字，轻松区分发言人'
        },
        {
          id: 5,
          url: require('@/assets/ly5.png'),
          tit: '门诊',
          cont: '门诊时间有限，精确记录医嘱，为身体健康保驾护航'
        },
        {
          id: 6,
          url: require('@/assets/ly6.png'),
          tit: '记者会',
          cont: '可实现实时记录、实时转写，会上记录，会后整理，为各方参会人员提供便利'
        }
      ],
      aaaa: false
    }
  },
  methods: {
    mshow() {
      this.aaaa = true
    },
    mhidden() {
      this.aaaa = false
    }
  }
}
</script>

<style lang="less" scoped>
.headBanner {
  background: url('../../assets/lybBanner.png');
  background-size: 100% 100%;
  .headClass {
    width: 1200px;
    height: 360px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .tit {
      width: 60%;
      color: #fff;
      text-align: left;
    }
    .div {
      width: 20%;
    }
  }
}
.contBox {
  padding: 30px;
  background: #f2f2f2;
  width: 1200px;
  margin: 0 auto;
  .subsystemCont {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    li {
      width: 250px;
      height: 100px;
      background-color: #fff;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 5px 5px 5px #36b2e7;
      border: 1px solid #2e5e9e;
      position: relative;
      margin-right: 50px;
      margin-bottom: 30px;
      .subsystemSpan {
        font-size: 22px;
        text-align: center;
      }
      .mask {
        width: 250px;
        height: 100px;
        background-color: #02a7f0;
        color: #fff;
        opacity: 0;
        position: absolute;
        top: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border-radius: 10px;
        padding: 5px;
        span:first-child {
          font-size: 18px;
          margin-bottom: 5px;
        }
        span:last-child {
          text-align: left;
        }
      }
    }
    li:hover .mask {
      opacity: 1;
      //  transition: all 0.5s ease 0s;
    }
  }
  .subsystemConts {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    li {
      width: 250px;
      height: 100px;
      background-color: #fff;
      border-radius: 10px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      box-shadow: 5px 5px 5px #36b2e7;
      border: 1px solid #2e5e9e;
      position: relative;
      margin-right: 50px;
      margin-bottom: 30px;
      img {
        width: 80px;
      }
      .subsystemSpan {
        font-size: 22px;
        text-align: center;
      }
      .mask {
        width: 250px;
        height: 100px;
        background-color: #02a7f0;
        color: #fff;
        opacity: 0;
        position: absolute;
        top: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border-radius: 10px;
        padding: 5px;
        span:first-child {
          font-size: 18px;
          margin-bottom: 5px;
        }
        span:last-child {
          text-align: left;
        }
      }
    }
    li:hover .mask {
      opacity: 1;
      //  transition: all 0.5s ease 0s;
    }
  }
}
</style>
